<script setup>
import { computed, onMounted } from 'vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import BaseSettingsHeader from '../../components/BaseSettingsHeader.vue';
import SettingsLayout from '../../SettingsLayout.vue';
import ConversationAssignmentPermissions from '../../account/components/ConversationAssignmentPermissions.vue';

const store = useStore();
const { accountId } = useAccount();
const getAccount = useMapGetter('accounts/getAccount');
const accountUiFlags = useMapGetter('accounts/getUIFlags');

const account = computed(() => getAccount.value(accountId.value) || {});

onMounted(() => {
  store.dispatch('accounts/get');
});
</script>

<template>
  <SettingsLayout
    :is-loading="accountUiFlags.isFetchingItem"
    :no-records-found="false"
    class="gap-8"
  >
    <template #header>
      <BaseSettingsHeader
        :title="$t('ASSIGNMENT_POLICY.ACCESS.HEADER.TITLE')"
        :description="$t('ASSIGNMENT_POLICY.ACCESS.HEADER.DESCRIPTION')"
        :back-button-label="$t('GENERAL_SETTINGS.BACK')"
      />
    </template>

    <template #body>
      <ConversationAssignmentPermissions v-if="account.id" :account="account" />
    </template>
  </SettingsLayout>
</template>
